import React, { useContext } from "react";
import { Card, CardContent, Grid, Typography } from "@material-ui/core";
// import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { makeStyles } from "@material-ui/core/styles";

import { SessionContext } from "../../../context/SessionContext";

const useStyles = makeStyles(theme => {
  return {
    actionCard: {
      "&:hover": {
        backgroundColor: theme.palette.primary.dark
      }
    },
    activeCard: {
      backgroundColor: theme.palette.primary.dark,
      borderLeft: `5px solid ${theme.palette.secondary.main}`
    },
    checkIcon: {
      color: theme.palette.secondary.light,
      marginLeft: "5px",
      marginRight: "auto",
      transform: "translate(0, 5px)"
    }
  };
});

const sections = [
  {
    id: "weather",
    label: "Marine Weather",
    subscribed: false,
    info: {
      link: "weather-api",
      title: "Marine Weather API",
      body:
        "Get access to our most advanced forecast model data that assimilates the industry's best with our proprietary observational buoy data. Forecast data is available up to 16 days into the future and updates hourly.",
      list: [
        "Request per geographic point",
        "Operational nowcast to 16-day forecast",
        "Includes data from WaveWatchIII, GFS, GDAS, GOFS, and HYCOM.",
        "Includes the Sofar Wave Model data"
      ],
      priceData: "$250 per month any geographic point",
      priceCalls: "100,000 calls per month, $1.4 per additional 10,000 calls"
    }
  },
  {
    id: "sensor",
    label: "Spotter Sensor",
    subscribed: false,
    info: {
      link: "spotter-sensor",
      title: "Spotter Sensor API",
      body:
        "Get real-time data from any Spotter device in the Sofar network. The Spotter Sensor API gives you a direct connection with our unique in-situ Spotter buoys that are deployed and operational all over the Pacific Ocean.",
      list: [
        "Request observational data from any buoy",
        "Wave statistics (bulk or full spectra + directional moments)",
        "U10 wind speed and direction",
        "Surface displacement (drift current)"
      ],
      priceData:
        "$50 per month, per Spotter (Standard) - $185 per month, per spotter (Spectrum) - $2500 per month for all. ",
      priceCalls: "100,000 calls per month, $1.4 per additional 10,000 calls"
    }
  },
  {
    id: "spectra",
    label: "Wave Spectra",
    subscribed: false,
    info: {
      link: "forecast",
      title: "Wave Spectra API",
      body:
        "Get the variance density spectrum at a single grid point from the Sofar global wave model at an hourly resolution for the duration of the entire forecast.",
      list: [
        "Request per geographic point",
        "NOAA WaveWatch III and Sofar Wave Model",
        "Operational spectral forecast",
        "Get boundary conditions for your own models"
      ],
      priceData: "$400 per month for 100 geographic points",
      priceCalls: "100,000 calls per month, $1.4 per additional 10,000 calls"
    }
  }
];

const APIProducts: React.FC<{}> = () => {
  const classes = useStyles();
  const { selectedApiCard, setSelectedApiCard } = useContext(SessionContext);

  return (
    <>
      {sections.map((section, index) => (
        <Card
          className={
            selectedApiCard.selectedIndex === index
              ? `${classes.activeCard} ${classes.actionCard}`
              : classes.actionCard
          }
          onClick={() => {
            setSelectedApiCard({
              section: section.info,
              selectedIndex: index
            });
          }}
          key={section.id}
        >
          <Grid container>
            <Grid xs={7} item>
              <CardContent>
                <Typography variant="h5">{section.label}</Typography>
              </CardContent>
            </Grid>
            <Grid xs={5} justify="flex-end" item container>
              <CardContent>
                {/* <Typography variant="h6" style={{ display: "inline" }}>
                  Subscribed
                </Typography>
                <CheckCircleIcon classes={{ root: classes.checkIcon }} /> */}
                <Typography color="textSecondary" variant="subtitle1">
                  Learn more +
                </Typography>
              </CardContent>
            </Grid>
          </Grid>
        </Card>
      ))}
    </>
  );
};

export default APIProducts;
